import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 14a7 7 0 1 0 14 0a7 7 0 1 0 -14 0","key":"svg-0"}],["path",{"d":"M9 14h6","key":"svg-1"}],["path",{"d":"M12 11l3 3l-3 3","key":"svg-2"}],["path",{"d":"M10 3l6.9 6","key":"svg-3"}]]

const IconBrandDoctrine = createReactComponent('outline', 'brand-doctrine', 'BrandDoctrine', __iconNode);

export default IconBrandDoctrine;